import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";

import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import InfoTooltip from "components/atoms/info/InfoTooltip";
import PageContainer from "components/templates/PageContainer";
import LocationCard from "components/molecules/card/LocationCard";
import { SnackContext } from "context/SnackProvider";
import instance, { getErrorMessage } from "api/definitions";

const PermissionReservation = (props) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const snackContext = useContext(SnackContext);

  useEffect(() => {
    if (props.load) {
      setIsLoaded(false);

      const fullURL = `local/${props.idLocation}/block`;

      instance
        .put(fullURL)
        .then(function (response) {
          setIsLoaded(true);
          const result = response.data;
          if (!result.performed) {
            snackContext.setMessage("Erro", "error");
          } else {
            snackContext.setMessage(
              `Permissão de reservas alterada com sucesso com sucesso`,
              "success"
            );
            props.handleClose();
          }
        })
        .catch(function (error) {
          setIsLoaded(true);
          const msg = getErrorMessage(error);
          snackContext.setMessage(msg, "error");
        });
    }
  }, [props, snackContext]);

  if (props.load && !isLoaded) return <CircularProgress />;
};

const LocationPermissionBlocked = (props) => {
  const [blocked, setBlocked] = useState(false);
  const [load, setLoad] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const navigate = useNavigate();
  const snackContext = useContext(SnackContext);

  useEffect(() => {
    setIsLoaded(false);

    const fullURL = `local/${props.id}`;

    instance
      .get(fullURL)
      .then(function (response) {
        setIsLoaded(true);
        const result = response.data;
        setBlocked(result.bloqueado);
      })
      .catch(function (error) {
        setIsLoaded(true);
        const msg = getErrorMessage(error);
        snackContext.setMessage(msg, "error");
      });
  }, [props, snackContext]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleBlocked = () => {
    setLoad(true);
  };

  const handleClose = () => {
    setLoad(false);
    navigate(-1);
  };

  if (!isLoaded) return <CircularProgress />;
  else {
    return (
      <PageContainer
        maxWidth="lg"
        title={"Gerenciar Bloqueio de Reservas do Local"}
        icon={<AccountBalanceIcon />}
      >
        <InfoTooltip placement="top-start" title="Voltar">
          <IconButton onClick={handleBack}>
            <ArrowBackIcon />
          </IconButton>
        </InfoTooltip>
        <Box sx={{ mt: 2 }}>
          <LocationCard id={props.id} />
        </Box>
        <Box sx={{ display: "inline-flex", mb: 2 }}>
          {blocked ? (
            <Button variant="contained" onClick={handleBlocked}>
              Desbloquear reservas
            </Button>
          ) : (
            <Button variant="contained" onClick={handleBlocked} color="error">
              Bloquear reservas
            </Button>
          )}

          <PermissionReservation
            idLocation={props.id}
            load={load}
            handleClose={handleClose}
          />
        </Box>
      </PageContainer>
    );
  }
};

export default LocationPermissionBlocked;
